var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-image",style:(_vm.imageStyle)},[_c('img',{attrs:{"src":require('@/assets/cutscene/content/' + _vm.src)}})])}
var staticRenderFns = []

export { render, staticRenderFns }